module.exports = __webpack_public_path__ + "static/media/icon_social-instagram.633c5237.svg";